import React from 'react';

import './gutter.css';

export const GutterLeft = () => (
  <div className="gutter gutter_left" />
);

export const GutterRight = () => (
  <div className="gutter gutter_right" />
);
